// src/services/ai/providers/GeminiProvider.js
import AIProvider from './AIProvider';

const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;
const GEMINI_API_URL = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent';

export default class GeminiProvider extends AIProvider {
  getName() {
    return 'gemini';
  }

  async chat(messages, tools = []) {
    if (!GEMINI_API_KEY) {
      throw new Error('Gemini API key not configured. Set REACT_APP_GEMINI_API_KEY.');
    }

    // Convert messages to Gemini format
    const systemInstruction = messages.find(m => m.role === 'system');
    const chatMessages = messages.filter(m => m.role !== 'system');

    const contents = chatMessages.map(msg => ({
      role: msg.role === 'assistant' ? 'model' : 'user',
      parts: [{ text: msg.content }]
    }));

    const body = { contents };

    // Add system instruction
    if (systemInstruction) {
      body.systemInstruction = { parts: [{ text: systemInstruction.content }] };
    }

    // Add tools if provided
    if (tools.length > 0) {
      body.tools = [{
        functionDeclarations: tools.map(tool => ({
          name: tool.name,
          description: tool.description,
          parameters: tool.parameters
        }))
      }];
    }

    const response = await fetch(`${GEMINI_API_URL}?key=${GEMINI_API_KEY}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error?.message || 'Gemini API error');
    }

    const data = await response.json();
    const candidate = data.candidates?.[0];
    if (!candidate?.content?.parts) {
      throw new Error('Unexpected Gemini response format');
    }

    const parts = candidate.content.parts;
    let content = '';
    let toolCalls = null;

    for (const part of parts) {
      if (part.text) {
        content += part.text;
      }
      if (part.functionCall) {
        if (!toolCalls) toolCalls = [];
        toolCalls.push({
          name: part.functionCall.name,
          args: part.functionCall.args || {}
        });
      }
    }

    return { content, toolCalls };
  }
}
